import { render, staticRenderFns } from "./MedicalHistory.vue?vue&type=template&id=6aa13970"
import script from "./MedicalHistory.vue?vue&type=script&lang=js"
export * from "./MedicalHistory.vue?vue&type=script&lang=js"
import style0 from "./MedicalHistory.vue?vue&type=style&index=0&id=6aa13970&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports